<template>
  <div class="overflow: auto">
    <div style="display: flex; flex-wrap: wrap">
      <div class="search_list">
        <div class="text">姓名/账号:</div>
        <Input
          style="width: 200px"
          v-model="keyword"
          @input="changeInput()"
          search
          class="select"
        />
      </div>
      <div class="search_list">
        <div class="text">选择状态:</div>
        <Select v-model="state" @on-change="changeInput" class="select">
          <Option v-for="item in types" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </div>
      <div class="search_list">
        <div class="text">按时间查询:</div>
        <DatePicker
          type="daterange"
          split-panels
          class="select"
          @on-change="queryTime"
        ></DatePicker>
      </div>
      <div class="search_list" style="display: flex; align-items: center">
        <div class="text">总额：{{ sumAmt }}</div>
      </div>
    </div>
    <Table
      style="font-size: 20px"
      :content="self"
      border
      stripe
      :columns="columns1"
      :data="data1"
    >
      <template slot-scope="{ row, index }" slot="reject">
        <Button
          style="background: red; border-color: red"
          type="error"
          v-if="row.state == '待处理'"
          size="small"
          @click="
            cause = true;
            rejectData = row;
          "
          >驳回</Button
        >
        <Button
          style="background: red; border-color: red"
          type="error"
          v-if="row.state == '待处理'"
          size="small"
          @click="
            shouDraw = true;
            DrawId = row.id;
          "
          >结算</Button
        >

        <Button
          style="background: red; border-color: red"
          type="error"
          v-if="row.refundState == 1"
          size="small"
          @click="
            showFailure = true;
            DrawId = row.id;
          "
          >退还金额</Button
        >
      </template>
    </Table>
    <Page
      style="margin-top: 10px"
      :total="total"
      @on-change="pagingSuery"
      show-elevator
    />
    <Modal width="40" v-model="cause" title="驳回" @on-ok="reject()">
      驳回原因：
      <Input v-model="remarks" style="width: 300px; margin-right: 15px" />
    </Modal>

    <Modal width="40" v-model="showFailure" title="退还金额" @on-ok="Failure()"
      >退还金额</Modal
    >
    <Modal width="40" v-model="shouDraw" title="结算" @on-ok="withdrawDraw()"
      >确认结算</Modal
    >
    <Modal
      width="40"
      v-model="shouDrawAYG"
      title="AYG结算"
      @on-ok="withdrawDrawAYG()"
      >确认结算</Modal
    >
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "DaKuan",

  data() {
    return {
      shouDrawAYG: false,
      cause: false,
      showFailure: false,
      shouDraw: false,
      DrawId: 0,
      groupName: "",
      rejectData: {},
      remarks: "",
      pageNow: 0,
      keyword: "",
      types: [
        {
          value: "0",
          label: "待处理",
        },
        {
          value: "1",
          label: "处理中",
        },
        {
          value: "2",
          label: "已驳回",
        },
        {
          value: "3",
          label: "已完成",
        },
        {
          value: "4",
          label: "失败",
        },
        // {
        //   value: "5",
        //   label: "已退还",
        // },
      ],
      state: "",
      time: [],
      self: this,
      total: 0,
      columns1: [
        {
          title: "用户名",
          align: "center",
          key: "username",
          width: 150,
        },
        {
          title: "手机号",
          key: "phone",
          align: "center",
          width: 200,
        },

        {
          title: "操作人",
          align: "center",
          key: "operName",
          width: 200,
        },
        {
          title: "银行卡号",
          align: "center",
          key: "cardNo",
          width: 200,
        },
        {
          title: "订单号",
          align: "center",
          key: "orderNo",
          width: 200,
        },
        {
          title: "提现金额/元",
          align: "center",
          key: "amount",
          width: 120,
        },

        {
          title: "状态",
          key: "state",
          align: "center",
          width: 100,
        },

        {
          title: "创建时间",
          align: "center",
          key: "createTime",
          width: 200,
        },
        {
          title: "结算时间",
          align: "center",
          key: "settleTime",
          width: 200,
        },
        {
          title: "修改时间",
          align: "center",
          key: "modifyTime",
          width: 200,
        },
        {
          title: "操作",
          key: "address",
          align: "center",
          slot: "reject",
          width: 200,
          fixed: "right",
        },
      ],
      data1: [{}],
      sumAmt: 0,
    };
  },
  mounted: function () {
    this.getData();
  },
  activated: function () {
    this.getData();
  },
  methods: {
    queryTime(time) {
      this.time[0] = Date.parse(new Date(time[0])) - 28800000;
      this.time[1] = Date.parse(new Date(time[1])) - 28800000 + 86400000;
      this.getData();
    },
    Failure() {
      api
        .WithdrawRefund({
          id: this.DrawId,
        })
        .then((res) => {
          this.getData();
          this.$layer.alert(res.body.message);
        });
    },
    withdrawDraw() {
      api
        .WithdrawDraw({
          id: this.DrawId,
        })
        .then((res) => {
          this.getData();
          this.$layer.alert(res.body.message);
        });
    },
    withdrawDrawAYG() {
      api
        .WithdrawDrawAYG({
          id: this.DrawId,
        })
        .then((res) => {
          this.getData();
          this.$layer.alert(res.body.message);
        });
    },

    reject() {
      api
        .withdrawReject({
          remarks: this.remarks,
          id: this.rejectData.id,
        })
        .then(() => {
          this.getData();
        });
    },
    getData() {
      api
        .WithdrawList({
          pageNow: this.pageNow,
          pageSize: 10,
          keyword: this.keyword,
          state: this.state,
          startMills: this.time[0],
          settlementWay: 1,
          endMills: this.time[1],
        })
        .then((res) => {
          this.sumAmt = res.body.data.sumAmt / 100;
          this.total = res.body.data.page.total;
          this.data1 = res.body.data.page.list;
          this.data1.forEach((element) => {
            if (element.state == 0) {
              element.state = "待处理";
            }
            if (element.state == 1) {
              element.state = "处理中";
            }
            if (element.state == 2) {
              element.state = "已驳回";
            }
            if (element.state == 3) {
              element.state = "已完成";
            }
            if (element.state == 4) {
              element.state = "失败";
            }
            if (element.state == 5) {
              element.state = "已退还";
            }
            element.amount = element.amount / 100;
            element.settleFee = element.settleFee / 100;
            element.actualAmount = element.actualAmount / 100;
          });
        });
    },

    changeInput() {
      this.pageNow = 0;
      this.getData();
    },
    pagingSuery(pageNow) {
      this.pageNow = pageNow;
      this.getData();
    },
  },
};
</script>

<style scoped lang = 'less'>
</style>